var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success-view"},[_c('img',{attrs:{"src":require("../../assets/group.png")}}),_c('p',{staticClass:"success-view-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"success-view-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }